import React, { useState } from 'react';
import { Modal } from '../../../../components/ui';
import RoomQuotationTemplate from '../../../../utils/RoomQuotationTemplate';
import { getQuotationData, generateQuotationPdf } from '../../../../utils/generateQuotationPdf';
import { Download, X } from 'lucide-react';
import { showSuccessMessage, showApiError } from '@/lib/toast';

export const QuotationPreviewModal = ({ isOpen, onClose, lead }) => {
  const [isGenerating, setIsGenerating] = useState(false);

  if (!lead || !isOpen) return null;

  const quotationData = getQuotationData(lead);

  const handleDownload = async () => {
    setIsGenerating(true);
    try {
      await generateQuotationPdf(lead);
      showSuccessMessage("Quotation PDF downloaded successfully!");
      onClose(); // Optional: close modal after successful download
    } catch (error) {
      console.error(error);
      showApiError({ message: "Failed to generate quotation PDF." });
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Quotation Preview" size="4xl" className="!rounded-md">
      <div className="flex flex-col h-[70vh]">
        {/* Preview Container - Scrollable area */}
        <div className="flex-1 overflow-auto bg-slate-100 p-8 rounded-lg border border-slate-200 custom-scrollbar flex justify-center">
          <div className="shadow-2xl bg-white transform origin-top w-full max-w-[900px] pointer-events-none select-none">
            {/* The actual template component */}
            <RoomQuotationTemplate data={quotationData} />
          </div>
        </div>

        {/* Footer Actions */}
        <div className="pt-5 mt-auto flex items-center justify-end gap-3 border-t border-slate-100">
          <button
            onClick={onClose}
            className="flex items-center gap-2 px-5 py-2.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-all font-bold text-[11px] uppercase tracking-wider"
          >
            <X size={14} />
            Cancel
          </button>
          
          <button
            onClick={handleDownload}
            disabled={isGenerating}
            className="flex items-center gap-2 px-6 py-2.5 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition-all font-bold text-[11px] uppercase tracking-wider shadow-sm disabled:opacity-70 disabled:cursor-not-allowed"
          >
            <Download size={14} />
            {isGenerating ? "Generating..." : "Download PDF"}
          </button>
        </div>
      </div>
    </Modal>
  );
};
